<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                            <div class="col-sm-11 d-flex flex-column">
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.table_use.label"
                                                :id="dataSearch.table_use.id"
                                                :placeholder="dataSearch.table_use.placeholder"
                                                :value-default="dataSearch.table_use.value"
                                                @inputValue="onChange($event, dataSearch.table_use.id)"
                                                :required="dataSearch.table_use.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.name.label"
                                                :id="dataSearch.name.id"
                                                :placeholder="dataSearch.name.placeholder"
                                                :value-default="dataSearch.name.value"
                                                @inputValue="onChange($event, dataSearch.name.id)"
                                                :required="dataSearch.name.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <SelectNormal
                                                :label="dataSearch.type.label"
                                                :id="dataSearch.type.id"
                                                :placeholder="dataSearch.type.placeholder"
                                                :value-default="dataSearch.type.value"
                                                @inputValue="onChange($event, dataSearch.type.id)"
                                                :required="dataSearch.type.required"
                                                :options="dataSearch.type.options"
                                        ></SelectNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-1 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSearch" @click="searchSettings"></ButtonSearchComponent>
                            </div>
                        </div>

                    </div>
                    <div class="btn-invite-partner">
                        <ButtonAddComponent :label="labelButtonCreate" @click="redirectToCreate"></ButtonAddComponent>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-between mt-4">
                        <div class="action d-flex align-items-center gap-3">
                            <div class="total">
                                {{ CommonText.TOTAL_RECORD(listSettingFile.length, paginate.itemCount) }}
                            </div>
                            <div class="dropdown-action">
                                <SelectCustom
                                        :label="selectAction.label"
                                        :id="selectAction.id"
                                        :placeholder="selectAction.placeholder"
                                        :value-default="selectAction.value"
                                        :required="selectAction.required"
                                        :options="selectAction.options"
                                        @action="actionSelect($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                    </div>
                    <div class="list-partners-component">
                        <table class="table">
                            <thead>
                            <tr>
                                <th scope="col" style="width: 2%;"><InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)" :checked="checkAll"></InputCheckboxOne></th>
                                <th scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="listSettingFile.length > 0" v-for="item in listSettingFile" :key="item.id" :style="{background: (item.status === 1 ? '#ebebe0' : '')}">
                                <td><InputCheckboxOne :id="item.id" :value-default="checkItems[item.id]" @inputValue="onChangeSelectItem($event, item.id)" :checked="checkItems[item.id]"></InputCheckboxOne></td>
                                <td class="file-name"><p @click="showSettingFile(item.id)">{{item.name}}</p></td>
                                <td>{{item.table_use}}</td>
                                <td>{{CommonService.compareTypeFileLabel(item.type)}}</td>
                                <td>{{item.description}}</td>
                                <td>{{CommonService.compareStatusFormatFileLabel(item.status)}}</td>
                            </tr>
                            <tr v-else>
                                <td colspan="8" class="text-center">Không có dữ lệu được tìm thấy!</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <PaginateComponent v-if="listSettingFile.length > 0 && paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
                </div>
            </div>
        </div>
    </div>
</div>
